import React, { useState, useRef, useEffect } from "react";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { useHistory } from "react-router-dom";
import { getData, postData, postData1, putData } from "../../services/http.service";
import Constants from "../../services/constant";
import { Chips } from "primereact/chips";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import service_dummy from "../../assets/demo/flags/service-dummy.svg";
import { Calendar } from "primereact/calendar";

const LoadOptionEdit = () => {
    const { id } = useParams();
    const toast = useRef(null);
    const history = useHistory();

    const [err, setErr] = useState({});
    const [optionImg, setOptionImg] = useState(null);
    const [loadOption, setLoadOption] = useState({
        name:"",
        optionName: "",
        loadTime:"",
        optionId: id,
    });

    const [loading, setLoading] = useState(true);

    console.log("loadOption", loadOption);
    console.log("optionImg", optionImg);

    const validateForm = () => {
        let errors = {};
        if (loadOption.optionName.length == 0) {
            errors.optionName = "Option Name is required";
        }
        if (loadOption.name.length == 0) {
            errors.name = "Name is required";
        }
        if (loadOption.loadTime.length == 0) {
            errors.loadTime = "Load Time is required";
        }
        if (!optionImg) {
            errors.image = "Image is required";
        }

        setErr(errors);
        if (Object.keys(errors).length === 0) {
            return true;
        } else {
            return false;
        }
    };

    const handleChangeOption = (e) => {
        const { name, value } = e.target;
            setLoadOption((prev) => {
                return {
                    ...prev,
                    [name]: value,
                };
            });
            setErr({ ...err, [name]: "" });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const form = validateForm();
        if (form) {
            if(typeof optionImg == "object"){
                const formData = new FormData();
                formData.append("serviceImage", optionImg);
                postData1(Constants.END_POINT.UPLOAD_IMAGE, formData)
                .then((res) => {
                    if (res.success) {
                        let payload = {
                            ...loadOption,
                            image:res.data.image,
                            loadTime:loadOption?.loadTime?.getHours() * 60 + loadOption?.loadTime?.getMinutes(),
                        };
                        putData(Constants.END_POINT.UPDATE_LOAD_OPTION + id, payload)
                        .then((res) => {
                            if (res.success) {
                                console.log("res", res);
                                toast.current.show({ severity: "info", summary: "", detail: "Option has been Updated Succesfully", life: 3000 });
                                setTimeout(() => history.goBack(), 1000);
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            }
            else{
                let payload = {
                    ...loadOption,
                    loadTime:loadOption?.loadTime?.getHours() * 60 + loadOption?.loadTime?.getMinutes(),
                };
                putData(Constants.END_POINT.UPDATE_LOAD_OPTION + id, payload)
                .then((res) => {
                    if (res.success) {
                        console.log("res", res);
                        toast.current.show({ severity: "info", summary: "", detail: "Option has been Updated Succesfully", life: 3000 });
                        setTimeout(() => history.goBack(), 1000);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            }
            
        }
    };


    useEffect(() => {
        getSingleOption();
    }, []);

    const getSingleOption = () => {
        getData(Constants.END_POINT.EDIT_LOAD_OPTION + id)
            .then((res) => {
                if (res.success) {
                    const loadHours = Math.floor(res?.data?.loadTime / 60);
                    const loadMinutes = res?.data?.loadTime % 60;
                    const currentDateLoad = new Date();
                    currentDateLoad.setHours(loadHours, loadMinutes, 0, 0);
                    let payload = {
                        ...res?.data,
                        loadTime:currentDateLoad
                    }
                    setLoadOption(payload)
                    if(res?.data?.image?.length>0){
                        setOptionImg(res?.data?.image)
                    }
                    setLoading(false);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <div className="grid">
            <div className="col-12 md:col-12 mx-auto">
                <Toast ref={toast} />
                <div className="card ">
                {loading ? 
                    <div className="overlay-loading">
                    <div class="spinner-border text-dark" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                : null}
                    <div className=" flex justify-content-left">
                        <h3>Update Option</h3>
                        <div className="ml-4 align-right"></div>
                    </div>
                    <div className="p-fluid grid question-div-wrapper mt-4">
                        <div className="field weapon-image-wrapper mt-4 col-12">
                            <div className="weapon-image-div">
                                <img src={typeof optionImg =="object"&&optionImg!=null ? URL.createObjectURL(optionImg) :typeof optionImg=="string"&&optionImg!=null ? Constants.BASE_URL+ optionImg:service_dummy} alt="" className="weaponImageTag" />
                                {optionImg !== null ? (
                                    <div className="weapon-edit-div">
                                        <i onClick={() => setOptionImg(null)} className="fa-sharp fa-solid fa-trash delete"></i>
                                    </div>
                                ) : null}
                            </div>

                            <input
                                type="file"
                                id="image"
                                name="image"
                                onChange={(e) => {
                                    setOptionImg(e.target.files[0]);
                                    setErr({ ...err, image: "" });
                                }}
                                onClick={(event) => {
                                    event.currentTarget.value = null;
                                }}
                                hidden
                            />
                            <label htmlFor="image" className="weaponImageLabel">
                                Update Image
                            </label>
                            <div className="text-danger">{err.image}</div>
                        </div>
                        <div className="field col-12 md:col-6">
                            <span className="p-float-label">
                                <InputText id="name" name="name" onChange={handleChangeOption} value={loadOption.name} />
                                <label htmlFor="name">Name</label>
                            </span>
                            <div className="text-danger">{err.name}</div>
                        </div>
                        <div className="field col-12 md:col-6">
                            <span className="p-float-label">
                                <InputText id="optionName" name="optionName" onChange={handleChangeOption} value={loadOption.optionName} />
                                <label htmlFor="optionName">Option Name</label>
                            </span>
                            <div className="text-danger">{err.optionName}</div>
                        </div>
                        {/* <div className="field col-12 md:col-6">
                            <span className="p-float-label">
                                <InputText id="loadTime" name="loadTime" onChange={handleChangeOption} value={loadOption.loadTime} />
                                <label htmlFor="loadTime">Load Time</label>
                            </span>
                            <div className="text-danger">{err.loadTime}</div>
                        </div> */}
                        <div className="field col-12 md:col-6">
                        <span className="p-float-label">
                        <Calendar id="loadTime" name="loadTime" value={loadOption.loadTime} onChange={handleChangeOption} showTime timeOnly />
                        <label htmlFor="loadTime">Load Time</label>
                                </span>
                                <div className="text-danger">{err.loadTime}</div>
                        </div>

                    </div>
                    <div className="flex justify-content-left mt-3 ">
                        {
                            <Button type="button" className="p-button-md p-button-success" onClick={handleSubmit}>
                                Update Option
                            </Button>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoadOptionEdit;
